import TriplicateInvoiceAllowanceOverviewPage from '@Local/Finance/TriplicateInvoiceAllowanceOverviewPage';
import { FINANCE_TRIPLICATE_INVOICE_ALLOWANCE_OVERVIEW_ROUTER } from '@Router/routerPath';
import { FRONT_KEY } from '@Constants/frontKey';

const financeRouter = [
	{
		description: '財務作業',
		frontKey: FRONT_KEY.FINANCE,
	},
	{
		description: '三聯發票折讓總覽',
		frontKey: FRONT_KEY.FINANCE_TRIPLICATE_INVOICE_ALLOWANCE_OVERVIEW,
		static: true,
		exact: true,
		path: FINANCE_TRIPLICATE_INVOICE_ALLOWANCE_OVERVIEW_ROUTER,
		href: FINANCE_TRIPLICATE_INVOICE_ALLOWANCE_OVERVIEW_ROUTER,
		as: TriplicateInvoiceAllowanceOverviewPage,
	},
];

export default financeRouter;
